import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import theme from './theme'
import Routers from './router/Routers'
import { getData, getLogoImage, initLanguage, logOut, saveDataIntoAsyncStore } from './utils/common';
import crmservices from './wsclient'
import { connection, portal_config } from './portal.config';
import { Languages } from './Languages';
import { cache } from './utils/cache';
import i18n from './translations/i18n'
import { useNavigate } from 'react-router-dom'
import { dataUtil } from './wsclient/crmservices/dataUtil'
export default function SetupApp(props) {
    const [isReady, setIsReady] = useState(false);
    const [message, setMessage] = useState(null);
    const [initSetupAppComplete, setInitSetupAppComplete] = useState(false);
    const [config, setConfig] = useState(null);
    const { t } = useTranslation();
    const navigate = useNavigate();
    let logoImage = getLogoImage();
    useEffect(() => {
        if (!initSetupAppComplete && !isReady) {
            setupApplication();
        }
    }, [])

    useEffect(() => {
        if (initSetupAppComplete && !isReady) {
            loadConfig();
            loadLanguages();
        }
    }, [initSetupAppComplete])

    const loadConfig = async () => {
        try {
            var result = await crmservices.config.getAppCfg({
                use_cname: connection.crmConfig.useCname,
                app_id: connection.crmConfig.applicationID,
                cname: connection.crmConfig.cname
            });
            if (result.code === 'OK') {
                var settings = result.data;
                cache.setAppConfig(settings);
                setConfig(settings)
                setIsReady(true);
            } else {
                cache.setAppConfig({});
                showMessage(true, t('ERROR'), t('GET_CONFIG_FAIL'))
            }
        } catch (error) {
            console.log("loadConfig exeption:", error);
            cache.setAppConfig({});
            showMessage(true, t('ERROR'), t('GET_CONFIG_FAIL'))
        }
    }

    const loadLanguages = async () => {
        let listLanguages = [];
        let defaultLanguages = portal_config.default_list_language;
        try {
            let result = await crmservices.config.getLanguages({ withAccessToken: false });
            if (result.code === 'OK') {
                let _strLanguages = i18n.options.resources;
                let languages = result.data && result.data.content ? result.data.content : [];
                languages.forEach(async item => {
                    let exLanguage = Languages.filter(x => x.code == item.language_code);
                    if (exLanguage && exLanguage.length > 0) {
                        if (_strLanguages && _strLanguages[exLanguage[0].code]) {
                            let tranLabel = exLanguage[0].value.toLowerCase();
                            listLanguages.push({
                                value: exLanguage[0].code,
                                label: t(tranLabel) ? t(tranLabel) : exLanguage[0].value,
                            });
                        }
                    }
                });
            }
        } catch (error) {
            console.log("loadLanguages exeption:", error);
        }
        if (listLanguages && listLanguages.length <= 0) {
            listLanguages = defaultLanguages;
        }
        cache.setLanguages(listLanguages);
    }

    const setupApplication = async () => {
        initLanguage();
        await crmservices.setupChannel({
            storeKVFn: async (key, value) => {
                saveDataIntoAsyncStore(key, value);
            },
            getKVFn: async (key) => {
                return getData(key);
            },
            sessionInvalidCallback: () => {
                logOut(true, navigate);
            },
            isBackend: true,
            apiKey: connection.crmConfig.crmApiKey,
            host: connection.crmConfig.crmServer,
            middlewareHost: connection.middlewareEnable && connection.middlewareConfig ? connection.middlewareConfig.mwServer : null,
            middlewareApiKey: connection.middlewareEnable && connection.middlewareConfig ? connection.middlewareConfig.mwApiKey : null,
        })
        setInitSetupAppComplete(true);
    }

    const showMessage = (status, title, message) => {
        setMessage({
            message: {
                show: status,
                title: title ? title : null,
                content: message ? message : null
            }
        })
    }
    console.log("AAAAAAA config:",config);
    // console.log("AAAA theme: ", theme(config))
    if (isReady) {
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme(config)}>
                    <CssBaseline />
                    <Routers appConfig={config} logoImage={logoImage}/>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    } else {
        return (
            <StyledEngineProvider injectFirst>
                <div style={{ display: 'flex', backgroundColor: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', minHeight: '100vh'}}>
                    {logoImage ? <img src={logoImage} alt='Logo' width={100} height={100} /> : <p>Loading...</p>}
                </div>
            </StyledEngineProvider>
        )
    }
}
